export default __webpack_public_path__ + "static/media/LogoWhite.1bb19ff6.svg";